import * as endpoints from 'pkg/api/endpoints/auto';
import * as sdk from 'pkg/core/sdk';

export const togglePublishedToPlayer = async (
	organizationId: number,
	id: number
) => {
	await sdk.patch(endpoints.UserRatings.Show(organizationId, id));
};

export const removeUserRating = async (
	organizationId: number,
	id: number
): Promise<boolean> => {
	const req = await sdk.destroy(
		endpoints.UserRatings.Destroy(organizationId, id)
	);

	return req.ok;
};

export const saveNewUserRating = async (
	organizationId: number,
	userId: number,
	requestObject: any
) => {
	const req = await sdk.post(
		endpoints.UserRatings.Create(organizationId, userId),
		{},
		requestObject
	);

	return req.json();
};
